import React, { useCallback, useState } from "react";
import { FC } from "react";
import { Field, useForm, useFormState } from "react-final-form";
import { FormRenderProps } from "react-final-form";
import { makeStyles } from "@material-ui/core";
import BootstrapInput from "../../../../../components/BootstrapInput";
import FormFieldsByRole from "./Content/FormFieldsByRole";
import { WeduAvatar } from "./Content/WeduAvatar";
import { useAuth } from "../../../../auth/hooks/useAuth";
import { UserRole } from "../../../enums/UserRole";
import { WizardMode } from "../../../../wizard/types";

const useStyles = makeStyles(() => ({
  mainContainer: {
    paddingRight: 7,
    "& > div": {
      paddingBottom: 16,
      minHeight: 64,
    },
  },
}));

export const EditProfileForm: FC<FormRenderProps> = ({ handleSubmit }) => {
  const classes = useStyles();
  const { change } = useForm();
  const { user } = useAuth();
  const { values } = useFormState();
  const [preview, setPreview] = useState(values.image);
  const isCreateMode = values.mode === WizardMode.Create;

  const onChange = useCallback(
    async (file) => {
      setPreview(URL.createObjectURL(file));

      change("profileImage", file);
    },
    [change],
  );

  const isAdminOrSupport = [
    UserRole.Owner,
    UserRole.Admin,
    UserRole.Support,
  ].includes(user.role);

  return (
    <form noValidate onSubmit={handleSubmit}>
      <div className={classes.mainContainer}>
        <WeduAvatar onChange={onChange} src={preview} />
        <FormFieldsByRole />
        <Field
          required
          fullWidth
          type="text"
          name="phone"
          label="Phone Number"
          placeholder="+19159969739"
          component={BootstrapInput}
        />
        <Field
          required
          disabled={!isCreateMode && !isAdminOrSupport}
          fullWidth
          type="text"
          name="email"
          label="Email"
          placeholder="example@test.com"
          component={BootstrapInput}
        />
      </div>
    </form>
  );
};
